define('Cubix_LooseDiamond/js/loosediamond_product',[
    "jquery",
    "Magento_Theme/js/view/messages",
    "ko",
    "Magento_Theme/js/handlebars.min",
    "Magento_Catalog/js/product/list/toolbar"

], function($, messageComponent, ko, Handlebars) {
    /**
     * ProductListToolbarForm Widget - this widget is setting cookie and submitting form according to toolbar controls
     */
    $.widget('mage.productListToolbarForm', $.mage.productListToolbarForm, {

        options:
        {
            pagerControl: '[data-role="pager"], .pages-items a',
            pager: 'p',
            limitDefault: '9',
            pagerDefault: '1',
            productsToolbarControl:'.order-products-toolbar',
            productsListBlock: '.products.wrapper',
            layeredNavigationFilterBlock: '.block.filter',
            filterItemControl: '.search-submit',
            diamondFilterControl: '.natural.priceTo,.natural.lab ,.natural.caratTo,.natural.colourVal,.natural.clarityVal,.natural.cutVal,.natural.flouVal,.natural.symmetryVal,.natural.polishVal,.natural.shape,.labgrown.shape,.labgrown.priceTo,.labgrown.lab ,.labgrown.caratTo,.labgrown.colourVal,.labgrown.clarityVal,.labgrown.cutVal,.labgrown.flouVal,.labgrown.symmetryVal,.labgrown.polishVal,.naturalfancy.shape,.naturalfancy.priceTo,.naturalfancy.lab ,.naturalfancy.caratTo,.naturalfancy.diamond_colour,.naturalfancy.clarityVal,.naturalfancy.intensityVal,.naturalfancy.flouVal,.naturalfancy.symmetryVal,.naturalfancy.polishVal,.labgrownfancy.shape,.labgrownfancy.priceTo,.labgrownfancy.lab ,.labgrownfancy.caratTo,.labgrownfancy.diamond_colour,.labgrownfancy.clarityVal,.labgrownfancy.intensityVal,.labgrownfancy.flouVal,.labgrownfancy.symmetryVal,.labgrownfancy.polishVal,.diamond_shape,.withimagevideo,.available_instore,.gemstone.priceTo,.gemstone.caratTo,.gemstone.shape,.gemstone.cutVal,.gemstone.diamond_gemtype,.gemstone.intensityVal,.gemstone.clarityVal,#diamond_type',
            url: '',
            shape: '',
            ring_builder: 0
        },

        _create: function () {
            var self = this;
            this.handlebarsHelper();
            //this._super();
            //this._bind($(this.options.pagerControl), this.options.pager, this.options.pagerDefault);
            $(this.options.filterItemControl)
                .off('click.'+this.namespace+'productListToolbarForm')
                .on('click.'+this.namespace+'productListToolbarForm', {}, $.proxy(this.applyFilterToProductsList, this))
            ;

            $(this.options.diamondFilterControl).off('change')
                .on('change', {}, $.proxy(this.applyFilterToProductsList, this));

            $(".viewtype").click(function(event){
                event.preventDefault();
                if(!$(this).hasClass('active')) {
                    $(".viewtype").removeClass('active');
                    $(this).addClass('active');
                    self.applyFilterToProductsList(); 
                }
            });
            
            $(document.body).on('click', '.clear-submit' ,function(evt){
                var diamond_type = $('input:radio[name=feed_diamond_type]:checked').val();
                $('.'+diamond_type+'.filter-searchbox').val('');
                $('.search-submit').click();
            });

            $(document).on("keypress", "input.filter-searchbox", function(e){
                if(e.which == 13){
                    $('.search-submit').click();
                }
            });
            
            $(document.body).on('click', '.mobile-diamond-total .close-btn' ,function(evt){
                $('html, body').stop().animate({
                    'scrollTop': $('.loose-diamonds-bg').offset().top-80
                }, 500, 'swing', function () {});
            });

            $(document.body).on('click', '.pages-items span.page,.pages-items span.next,.pages-items span.previous' ,function(evt){
                evt.preventDefault();
                if(!$(this).hasClass('active')) {
                    self.applyFilterToProductsList(evt); 
                }
            });

            $(".custom-checkbox.disabled").click(function() {
                $(".shape-error").show().delay(3000).fadeOut();
            });

            $(".advance-filter-bnt").click(function(){
                $(this).toggleClass("up down");
                var diamondtype = $(this).data('diamondtype');
                $('.advance-filter-main.'+diamondtype).toggleClass("show hide");
            });

            var ring_builder = self.options.ring_builder;
            if(ring_builder==1) {
                this.makeAjaxCall();
            }
        },
        applyFilterToProductsList: function (evt) {
            var self = this;
            if($('#disableajax').length && $('#disableajax').val()==1) {
                return false;
            }
            if(evt !== undefined) {
                var link = $(evt.currentTarget).attr('data-href');
                evt.preventDefault();
            }

            if(link=='' || link===undefined) {
                var link  = self.options.url;
            }
            
            var urlParts = link.split('?');
            this.makeAjaxCall(urlParts[0], urlParts[1]);
            
        },
        makeAjaxCall: function (baseUrl, paramData) {
            $('.diamondtype-list').css('opacity', '0.2');
            $('#dh_loading').show();
            var self = this;
            var diamond_type = $('input:radio[name=feed_diamond_type]:checked').val();
            
            var clarity = $('.'+diamond_type+'.clarityVal').val();
            if(diamond_type=='naturalfancy' || diamond_type=='labgrownfancy') {
                $('.'+diamond_type+'.diamond_colour').parent().removeClass('active');
                var colour = $('.'+diamond_type+'.diamond_colour:checked').val();
                $('.'+diamond_type+'.diamond_colour:checked').parent().addClass('active');
            }
            else {
                var colour = $('.'+diamond_type+'.colourVal').val();
            }

            var gemtype = '';
            if(diamond_type=='gemstone') {
                $('.'+diamond_type+'.diamond_gemtype').parent().removeClass('active');
                var gemtype = $('.'+diamond_type+'.diamond_gemtype:checked').val();
                $('.'+diamond_type+'.diamond_gemtype:checked').parent().addClass('active');
            }
            
            var cut = $('.'+diamond_type+'.cutVal').val();
            var intensity = $('.'+diamond_type+'.intensityVal').val();
            var viewtype = $('.viewtype.active').data('view');
            var carat = $('.'+diamond_type+'.caratFrom').val() + '-' + $('.'+diamond_type+'.caratTo').val();
            var price = $('.'+diamond_type+'.priceFrom').val() + '-' + $('.'+diamond_type+'.priceTo').val();
            var polish = $('.'+diamond_type+'.polishVal').val();
            var symmetry = $('.'+diamond_type+'.symmetryVal').val();
            var flou = $('.'+diamond_type+'.flouVal').val();
            var withimagevideo = $('.withimagevideo').prop("checked");
            var available_instore = $('.available_instore').prop("checked");
            var search = $('.'+diamond_type+'.search').val();

            if(search != '') {
                $('.search-submit').hide();
                $('.clear-submit').show();
            }
            else {
                $('.clear-submit').hide();
                $('.search-submit').show();
            }
            
            var lab = [];
            $.each($('.'+diamond_type+'.lab:checked'), function(){
                lab.push($(this).val());
            });
            
            if(lab.length === 0) {
                $('.'+diamond_type+'.labtext').text('All');
            }
            else {
                $('.'+diamond_type+'.labtext').text(lab.join(","));
            }

            //var shape = self.options.shape;
            var ring_builder = self.options.ring_builder;
            var shape = [];
            if(ring_builder==1) {
                
                var cat_url_key=  $('input:radio[name=feed_diamond_type]:checked').data('urlkey'); 
                $('#cat_url_key').val(cat_url_key); 
                $('.'+diamond_type+'.shape').parent().removeClass('selected');
                $.each($('.'+diamond_type+'.shape:checked'), function() {
                    var shape_val = $(this).val();
                    shape.push($(this).val());
                    shape_val = shape_val.toLowerCase();
                    $('.'+diamond_type+'.shape:checked').parent().addClass('selected');
                });

                var currUrl = document.URL;
                var urlPaths = currUrl.split('/by-stone');
                var newUrl = urlPaths[0] ? urlPaths[0] : '';
                console.log(newUrl);
                newUrl = newUrl + '/by-stone/' + cat_url_key;
                window.history.replaceState({url: newUrl}, document.title,newUrl);
            }
            else {
                shape.push(self.options.shape);
            }
            
            $('.rb-error').addClass('d-none');
            /*if(shape.length == 0) {
                $('.'+diamond_type+'-error').removeClass('d-none').text('Please select shape');
                $('.diamondtype-list').css('opacity', '1');
                $('#dh_loading').hide();
                return false;
            }*/

            if(shape.length == 1 && (shape[0] == 'Round' || shape[0] == 'round')) {
                $('#diamondtype-filters-feed-'+diamond_type+' .cutmain').show();
            }
            else {
                $('#diamondtype-filters-feed-'+diamond_type+' .cutmain').hide();
            }

            // if(shape!='Round' && diamond_type!='gemstone') {
            //     $('.diamondtype-'+diamond_type+' .cutmain').hide();                
            // }
            // else {
            //     $('.diamondtype-'+diamond_type+' .cutmain').show();
            // }

            var data = {
                ajax : 1,
                is_product_page : 1,
                diamond_type : diamond_type,
                clarity : clarity,
                colour : colour,
                cut : cut,
                intensity : intensity,
                p: self.getURLParameter(paramData,'p'),
                itemsPerPage: self.options.limitDefault,
                viewtype: viewtype,
                shape: shape,
                s: shape,
                carat: carat,
                price: price, 
                lab: lab,
                polish: polish,
                symmetry: symmetry,
                flou: flou,
                withimagevideo: withimagevideo,
                available_instore: available_instore,
                search : search,
                gemtype : gemtype,
                ring_builder : ring_builder
            };

            var store_code = self.options.store_code;
            if(store_code && store_code != "dh"){
                data["price_"+store_code] = price;
            }

            $('.loading').css("visibility","visible");
            $.ajax({
                url: self.options.url,
                data: data,
                type: 'post',
                dataType: 'json',
                cache: true,
                showLoader: false
            }).done(function (response) {
                if (response.result == 'success') {
                    self.drawDiamondTable(response);
                    self.drawDiamondTablePagination(response.pagination);
                    if(diamond_type=='naturalfancy' || diamond_type=='gemstone' || diamond_type=='labgrownfancy') {
                        $('.diamondtype-list .cut').hide();
                        $('.diamondtype-list .intensity').show();
                        if(diamond_type=='gemstone') {
                            $('.diamondtype-list .cert').hide();
                            $('.diamondtype-list .gemtype').show();
                        }
                        else {
                            $('.diamondtype-list .gemtype').hide();
                        }
                    }
                    else {
                        $('.diamondtype-list .cut').show();
                        $('.diamondtype-list .intensity').hide();
                        $('.diamondtype-list .cert').show();
                        $('.diamondtype-list .gemtype').hide();
                    }
                    var metal = $(".metal_type_option:checked").data("metal");
                    if($('.'+ metal + '_squere.gallery_switcher').length) {
                        var gallery = $('.'+ metal + '_squere.gallery_switcher').data('gallery')[1];
                        $('.diamond-product-img').attr('src',gallery.img);
                    }
                    
                    $('.pdp-diamondlist').trigger('contentUpdated');

                    var btn_label = 'Add To Ring';
                    var attributesetname = $('#attributeset').val();
                    if(attributesetname=='Feed Pendants' || attributesetname=='DH Feed Pendants' ) {
                        btn_label = 'Add To Pendant';
                    }
                    $('.diamond-btn-txt').text(btn_label);
                    window.__sharethis__.initialize();
                } else {
                    var msg = response.error_message;
                    if (msg) {
                        self.setMessage({
                            type: 'error',
                            text: msg
                        });
                    }
                }
                $('.diamondtype-list').css('opacity', '1');
                $('#dh_loading').hide();
            }).fail(function (error) {
                $('.loading').css("visibility","hidden");
            });
        },
        getURLParameter: function (paramData,sParam) {
            if(paramData!='' && paramData!=undefined) {
                var sURLVariables = paramData.split('&');
                for (var i = 0; i < sURLVariables.length; i++)
                {
                    var sParameterName = sURLVariables[i].split('=');
                    if (sParameterName[0] == sParam)
                    {
                        return decodeURIComponent(sParameterName[1]);
                    }
                }
            }
        },
        handlebarsHelper: function () {
            Handlebars.registerHelper('ifEquals', function(arg1, arg2, options) {
                return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
            });

            Handlebars.registerHelper('JSON2string', function (object) {
                return JSON.stringify(object);
            });
        },
        drawDiamondTable: function (data) {
            if (data.data.length != 0) {
                var source = document.getElementById("template-diamondtable").innerHTML;
                var template = Handlebars.compile(source);
                var html = template(data);
                jQuery('.pdp-diamondlist').html(html);
            }
            else {
                jQuery('.pdp-diamondlist').html('<div class="diamond-table-rows nodiamonds">No result found</div>');
            }
        },
        drawDiamondTablePagination: function(pagination) {
            var self = this;
            var firstPage = parseInt(pagination.currentPage) - 1;
        
            if (firstPage < 1) {
                firstPage = 1;
            }
        
            var lastPage = parseInt(pagination.currentPage) + 5;
            if (lastPage > parseInt(pagination.totalPages)) {
                lastPage = parseInt(pagination.totalPages);
                firstPage = ((lastPage - 5) > 0) ? lastPage - 5 : 1;
            }
            var showPrev = (firstPage < parseInt(pagination.currentPage));
            var showNext = (lastPage > parseInt(pagination.currentPage));
        
            var data = {
                pagelinks:[]
            }
        
            data.totalpage = parseInt(pagination.totalPages);
            data.currentpage = parseInt(pagination.currentPage);
            
            if (showPrev) {
                data.pagelinks.push({
                    page: self.options.url + '?p=' + (parseInt(pagination.currentPage)-1),
                    label:'<i class="fas  fa-angle-left fa-fw"></i>',
                    class:'previous'
                });
            }

            for (var i=firstPage;i<=lastPage;i++) {
                var cls = (i==pagination.currentPage ? 'page-link active' : 'page-link');
                data.pagelinks.push({
                    page: self.options.url + '?p=' + i,
                    label:i,
                    class:cls
                });
            }
        
            if (showNext) {
                data.pagelinks.push({
                    page:self.options.url + '?p=' + (parseInt(pagination.currentPage)+1),
                    label:'<i class="fas  fa-angle-right fa-fw"></i>',
                    class:'next'
                });
            }

            if(pagination.totalItems > 9) {
                if(pagination.currentPage==1) {
                    var start = pagination.currentPage;
                }
                else {
                    var start = ((pagination.currentPage-1) * pagination.itemsPerPage)+1;
                }

                if(pagination.currentPage * pagination.itemsPerPage > pagination.totalItems) {
                    var end = pagination.totalItems;
                }
                else {
                    var end = pagination.currentPage * pagination.itemsPerPage;
                }
                var pagination_info = "Items " + start + " to " + end + " of " + pagination.totalItems + " total";
            }
            else {
                /*var pagination_info = "Items " + (pagination.currentPage) + " to " + pagination.totalItems + " of " + pagination.totalItems + " total";*/
                if(pagination.totalItems <= 1) {
                    var pagination_info = "Showing " + pagination.totalItems + " Item";
                }
                else {
                    var pagination_info = "Showing " + pagination.totalItems + " Items";
                }
            }

            $('.toolbar-number').html(pagination_info);
            $('.mobile-diamond-total button').text('View ' + pagination.totalItems + ' Results');
        
            var template = 'template-table-pagination';
            var source   = document.getElementById(template).innerHTML;
            var template = Handlebars.compile(source);
            var html     = template(data);
            $('.feed-pagination').html(html);
        }

    });

    return $.mage.productListToolbarForm;
});
